<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">

    <div class="row mb-4 header-row">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Tabela ANP</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="/configuracoes/notas-fiscais">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Gestão dos códigos ANP e do mapeamento NCM × ANP da sua empresa.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-flat-button class="btn-primary" (click)="abrirModalCodigo(null)">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Adicionar código ANP
        </button>
        <button mat-stroked-button class="btn-primary" (click)="abrirModalNcm()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Adicionar mapeamento NCM x ANP
        </button>
      </div>
    </div>

    <mat-tab-group [(selectedIndex)]="abaAtivaIndex" (selectedIndexChange)="onTabChange($event)" class="anp-tabs"
      appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true">

      <!-- ============ ABA CÓDIGOS ANP ============ -->
      <mat-tab label="Códigos ANP">

        <form [formGroup]="modelCodigos" (ngSubmit)="clickPesquisarCodigos()">
          <div class="search-area anp-toolbar">
            <div class="anp-filtros">
              <mat-form-field appearance="outline" class="anp-search" subscriptSizing="dynamic">
                <mat-label>Pesquisar</mat-label>
                <input matInput type="text" formControlName="pesquisa" placeholder="Busque por código ou descrição" />
                <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>

              <button #filtrosMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
                [matBadge]="qtdFiltrosCodigos" [matBadgeHidden]="qtdFiltrosCodigos === 0">
                <mat-icon>filter_list</mat-icon>
                Filtrar
              </button>
              <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                <div class="filter-menu-content" [formGroup]="modelCodigos">
                  <div (click)="$event.stopPropagation()">
                    <h6>Filtros Avançados</h6>
                    <div class="filter-menu__form">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Regime ICMS</mat-label>
                        <mat-select formControlName="idRegimeIcms">
                          <mat-option [value]="null">Todos</mat-option>
                          @for (r of regimes; track r.id) {
                          <mat-option [value]="r.id">{{ r.descricao }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>% mistura Biodiesel (pBio)</mat-label>
                        <mat-select formControlName="exigePbio">
                          <mat-option [value]="null">Todos</mat-option>
                          <mat-option [value]="true">Sim</mat-option>
                          <mat-option [value]="false">Não</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Grupo GLP</mat-label>
                        <mat-select formControlName="exigeGrupoGlp">
                          <mat-option [value]="null">Todos</mat-option>
                          <mat-option [value]="true">Sim</mat-option>
                          <mat-option [value]="false">Não</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="isAtivo">
                          <mat-option [value]="null">Todos</mat-option>
                          <mat-option [value]="true">Ativo</mat-option>
                          <mat-option [value]="false">Inativo</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="filter-menu__actions">
                    <button mat-button class="btn-secondary" matMenuClose
                      (click)="filtrosMenuTrigger.closeMenu()">Cancelar</button>
                    <button mat-flat-button class="btn-primary" matMenuClose
                      (click)="aplicarFiltrosCodigos()">Aplicar</button>
                  </div>
                </div>
              </mat-menu>

              <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltrosCodigos()">
                <mat-icon>cleaning_services</mat-icon>
                Limpar Filtros
              </button>
            </div>
          </div>
        </form>

        @if (_isLoadingCodigos && _dataSourceCodigos.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (_dataSourceCodigos.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSourceCodigos" matSort #sortCodigos="matSort"
          matSortActive="codigo" matSortDirection="asc">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Código ANP</th>
            <td mat-cell *matCellDef="let row"><strong>{{ row.codigo }}</strong></td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição ANP</th>
            <td mat-cell *matCellDef="let row">{{ row.descricao }}</td>
          </ng-container>
          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef>Unid.</th>
            <td mat-cell *matCellDef="let row">{{ unidadeLabel(row.idUnidadeMedida) }}</td>
          </ng-container>
          <ng-container matColumnDef="regime">
            <th mat-header-cell *matHeaderCellDef>Regime ICMS</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-badge" [class.badge-azul]="row.idRegimeIcms === RegimeIcmsEnum.Monofasico"
                [class.badge-cinza]="row.idRegimeIcms !== RegimeIcmsEnum.Monofasico">
                {{ row.regimeIcmsDescricao }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="aliquota">
            <th mat-header-cell *matHeaderCellDef class="text-right">Alíquota ad rem (R$)</th>
            <td mat-cell *matCellDef="let row" class="text-right">
              {{ row.aliquotaIcmsPorUnidade ? (row.aliquotaIcmsPorUnidade | number:'1.4-4') : '—' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="pbio">
            <th mat-header-cell *matHeaderCellDef class="text-center">pBio</th>
            <td mat-cell *matCellDef="let row" class="text-center">
              <span class="status-badge" [class.badge-verde]="row.exigePbio" [class.badge-cinza]="!row.exigePbio">{{
                row.exigePbio ? 'Sim' : 'Não' }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="glp">
            <th mat-header-cell *matHeaderCellDef class="text-center">Grupo GLP</th>
            <td mat-cell *matCellDef="let row" class="text-center">
              <span class="status-badge" [class.badge-verde]="row.exigeGrupoGlp"
                [class.badge-cinza]="!row.exigeGrupoGlp">{{ row.exigeGrupoGlp ? 'Sim' : 'Não' }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-badge" [class.badge-verde]="row.isAtivo" [class.badge-cinza]="!row.isAtivo">
                {{ row.isAtivo ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center w-actions">
              <button mat-icon-button [matMenuTriggerFor]="menu"><span
                  class="material-symbols-outlined">more_horiz</span></button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="alternarStatusCodigo(row)">
                  <span class="material-symbols-outlined">{{ row.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
                  <span>{{ row.isAtivo ? 'Inativar' : 'Ativar' }}</span>
                </button>
                <button mat-menu-item (click)="abrirModalCodigo(row)">
                  <span class="material-symbols-outlined">edit</span><span>Editar</span>
                </button>
                <button mat-menu-item (click)="excluirCodigo(row)">
                  <span class="material-symbols-outlined">delete</span><span>Excluir</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="colunasCodigos"></tr>
          <tr mat-row *matRowDef="let row; columns: colunasCodigos;"></tr>
        </table>

        <div class="mobile-view">
          @for (row of _dataSourceCodigos.data; track row.idAnpEmpresa) {
          <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <span class="text-bold">{{ row.codigo }}</span>
                <small>{{ row.descricao }}</small>
              </div>
              <button mat-icon-button [matMenuTriggerFor]="menuMobile"><span
                  class="material-symbols-outlined">more_horiz</span></button>
              <mat-menu #menuMobile="matMenu">
                <button mat-menu-item (click)="alternarStatusCodigo(row)">
                  <span class="material-symbols-outlined">{{ row.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
                  <span>{{ row.isAtivo ? 'Inativar' : 'Ativar' }}</span>
                </button>
                <button mat-menu-item (click)="abrirModalCodigo(row)">Editar</button>
                <button mat-menu-item (click)="excluirCodigo(row)">Excluir</button>
              </mat-menu>
            </div>
            <div class="card-body-mobile">
              <div class="card-grid-2">
                <div class="card-field">
                  <small class="d-block">Unid. · Regime</small>
                  <span>{{ unidadeLabel(row.idUnidadeMedida) }} · {{ row.regimeIcmsDescricao }}</span>
                </div>
                <div class="card-field">
                  <small class="d-block">Alíquota ad rem</small>
                  <span>{{ row.aliquotaIcmsPorUnidade ? (row.aliquotaIcmsPorUnidade | number:'1.4-4') : '—' }}</span>
                </div>
                <div class="card-field">
                  <small class="d-block">pBio</small>
                  <span class="status-badge" [class.badge-verde]="row.exigePbio" [class.badge-cinza]="!row.exigePbio">
                    {{ row.exigePbio ? 'Sim' : 'Não' }}
                  </span>
                </div>
                <div class="card-field">
                  <small class="d-block">Grupo GLP</small>
                  <span class="status-badge" [class.badge-verde]="row.exigeGrupoGlp"
                    [class.badge-cinza]="!row.exigeGrupoGlp">
                    {{ row.exigeGrupoGlp ? 'Sim' : 'Não' }}
                  </span>
                </div>
                <div class="card-field">
                  <small class="d-block">Status</small>
                  <span class="status-badge" [class.badge-verde]="row.isAtivo" [class.badge-cinza]="!row.isAtivo">
                    {{ row.isAtivo ? 'Ativo' : 'Inativo' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
          <button mat-button class="btn-ver-mais"
            [disabled]="_isLoadingCodigos || _dataSourceCodigos.data.length >= _totalCodigos"
            (click)="proximaPaginaCodigos()">
            @if (_isLoadingCodigos) { <mat-spinner [diameter]="20"></mat-spinner> } @else { <span
              class="material-symbols-outlined">expand_more</span> Ver Mais }
          </button>
        </div>

        } @else {
        <app-empty-list [title]="'Nenhum código ANP encontrado'"
          [subTitle]="'Tente alterar a busca ou os filtros'"></app-empty-list>
        }
      </mat-tab>

      <!-- ============ ABA MAPEAMENTO NCM × ANP ============ -->
      <mat-tab label="Mapeamento NCM × ANP">

        <form [formGroup]="modelNcm" (ngSubmit)="clickPesquisarNcm()">
          <div class="search-area anp-toolbar">
            <div class="anp-filtros">
              <mat-form-field appearance="outline" class="anp-search" subscriptSizing="dynamic">
                <mat-label>Pesquisar</mat-label>
                <input matInput type="text" formControlName="pesquisa" placeholder="Busque por NCM ou descrição" />
                <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </form>

        <app-alert-card type="info">
          NCMs mapeados aqui ativam automaticamente a seção <strong>Dados ANP</strong> no cadastro de produto.
        </app-alert-card>

        @if (_isLoadingNcm && _dataSourceNcm.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (_dataSourceNcm.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSourceNcm" matSort #sortNcm="matSort"
          matSortActive="codigoNcm" matSortDirection="asc">
          <ng-container matColumnDef="codigoNcm">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>NCM</th>
            <td mat-cell *matCellDef="let row"><strong>{{ row.codigoNcm | mask: '0000.00.00' }}</strong></td>
          </ng-container>
          <ng-container matColumnDef="descricaoNcm">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição NCM</th>
            <td mat-cell *matCellDef="let row">{{ row.descricaoNcm }}</td>
          </ng-container>
          <ng-container matColumnDef="nivel">
            <th mat-header-cell *matHeaderCellDef>Nível de Aplicação</th>
            <td mat-cell *matCellDef="let row"><span class="status-badge badge-azul">{{ row.nivelAplicacao }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-badge" [class.badge-verde]="row.isAtivo" [class.badge-cinza]="!row.isAtivo">
                {{ row.isAtivo ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center w-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuNcm"><span
                  class="material-symbols-outlined">more_horiz</span></button>
              <mat-menu #menuNcm="matMenu">
                <button mat-menu-item (click)="alternarStatusNcm(row)">
                  <span class="material-symbols-outlined">{{ row.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
                  <span>{{ row.isAtivo ? 'Inativar' : 'Ativar' }}</span>
                </button>
                <button mat-menu-item (click)="excluirNcm(row)">
                  <span class="material-symbols-outlined">delete</span><span>Excluir</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="colunasNcm"></tr>
          <tr mat-row *matRowDef="let row; columns: colunasNcm;"></tr>
        </table>

        <div class="mobile-view">
          @for (row of _dataSourceNcm.data; track row.idAnpEmpresaNcm) {
          <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <span class="text-bold">{{ row.codigoNcm | mask: '0000.00.00' }}</span>
                <small>{{ row.descricaoNcm }}</small>
              </div>
              <button mat-icon-button [matMenuTriggerFor]="menuNcmMobile"><span
                  class="material-symbols-outlined">more_horiz</span></button>
              <mat-menu #menuNcmMobile="matMenu">
                <button mat-menu-item (click)="alternarStatusNcm(row)">
                  <span class="material-symbols-outlined">{{ row.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
                  <span>{{ row.isAtivo ? 'Inativar' : 'Ativar' }}</span>
                </button>
                <button mat-menu-item (click)="excluirNcm(row)">Excluir</button>
              </mat-menu>
            </div>
            <div class="card-body-mobile">
              <div class="card-grid-2">
                <div class="card-field">
                  <small class="d-block">Nível de Aplicação</small>
                  <span class="status-badge badge-azul">{{ row.nivelAplicacao }}</span>
                </div>
                <div class="card-field">
                  <small class="d-block">Status</small>
                  <span class="status-badge" [class.badge-verde]="row.isAtivo" [class.badge-cinza]="!row.isAtivo">
                    {{ row.isAtivo ? 'Ativo' : 'Inativo' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
          <button mat-button class="btn-ver-mais" [disabled]="_isLoadingNcm || _dataSourceNcm.data.length >= _totalNcms"
            (click)="proximaPaginaNcm()">
            @if (_isLoadingNcm) { <mat-spinner [diameter]="20"></mat-spinner> } @else { <span
              class="material-symbols-outlined">expand_more</span> Ver Mais }
          </button>
        </div>

        } @else {
        <app-empty-list [title]="'Nenhum mapeamento encontrado'"
          [subTitle]="'Adicione um novo mapeamento NCM para começar'"></app-empty-list>
        }
      </mat-tab>

    </mat-tab-group>
  </div>
</div>
